/* PADEL GRAIL racket compare. Stores picked rackets in localStorage and renders a
   centered, responsive compare modal from that data. No app, no API calls. */
(function () {
  'use strict';
  var KEY = 'pgCompareV1', MAX = 4;
  var SET = {
    year: ['2024', '2025', '2026'],
    player: ['Unisex', 'Women', 'Kids'],
    level: ['Beginner', 'Intermediate', 'Advanced'],
    type: ['Power', 'Control', 'All-round'],
    hardness: ['Soft', 'Firm', 'Hard']
  };

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(a) { localStorage.setItem(KEY, JSON.stringify(a)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pick(tags, set) { tags = tags || []; for (var i = 0; i < set.length; i++) if (tags.indexOf(set[i]) > -1) return set[i]; return ''; }
  function levelsOf(tags) { return SET.level.filter(function (l) { return (tags || []).indexOf(l) > -1; }); }
  function txt(v) { return v ? esc(v) : '<span class="pg-cmp-muted">&mdash;</span>'; }

  /* ---- spec cue renderers ---- */
  function shapeCue(v) {
    if (!v) return txt(v);
    var p = { Diamond: '<path d="M10 2 18 10 10 18 2 10Z"/>', Round: '<circle cx="10" cy="10" r="8"/>',
      Teardrop: '<path d="M10 2.5C14 8 16.5 10.5 16.5 12.5a6.5 6.5 0 1 1-13 0C3.5 10.5 6 8 10 2.5Z"/>',
      Hybrid: '<rect x="3" y="3" width="14" height="14" rx="5"/>' }[v] || '<circle cx="10" cy="10" r="8"/>';
    return '<span class="pg-cmp-cue__row"><svg class="pg-cmp-shape" viewBox="0 0 20 20" aria-hidden="true">' + p + '</svg>' + esc(v) + '</span>';
  }
  function segCue(v, order) {
    var n = order.indexOf(v) + 1;
    if (n < 1) return txt(v);
    var bars = '';
    for (var i = 1; i <= 3; i++) bars += '<span class="' + (i <= n ? 'on' : '') + '"></span>';
    return '<span class="pg-cmp-cue"><span class="pg-cmp-seg">' + bars + '</span><span>' + esc(v) + '</span></span>';
  }
  function levelCue(tags) {
    var ls = levelsOf(tags); if (!ls.length) return txt('');
    var n = Math.max.apply(null, ls.map(function (l) { return SET.level.indexOf(l) + 1; }));
    var d = ''; for (var i = 1; i <= 3; i++) d += '<span class="' + (i <= n ? 'on' : '') + '"></span>';
    var ab = { Beginner: 'Beg', Intermediate: 'Int', Advanced: 'Adv' };
    var label = ls.length > 1 ? ls.map(function (l) { return ab[l]; }).join(' / ') : ls[0];
    return '<span class="pg-cmp-cue"><span class="pg-cmp-dots">' + d + '</span><span>' + esc(label) + '</span></span>';
  }
  function typeCue(v) {
    if (!v) return txt(v);
    var icon = {
      Power: '<svg viewBox="0 0 20 20" fill="#BA7517" aria-hidden="true"><path d="M11 1 4 11h4l-1 8 7-10h-4z"/></svg>',
      Control: '<svg viewBox="0 0 20 20" fill="none" stroke="#185FA5" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="7"/><circle cx="10" cy="10" r="2.4"/></svg>',
      'All-round': '<svg viewBox="0 0 20 20" fill="none" stroke="#0F6E56" stroke-width="1.6" aria-hidden="true"><circle cx="10" cy="10" r="7"/><path d="M3 10h14"/></svg>'
    }[v] || '';
    return '<span class="pg-cmp-type">' + icon + esc(v) + '</span>';
  }
  function boolCue(b) { return b ? '<span class="pg-cmp-bool yes" aria-label="yes">&#10003;</span>' : '<span class="pg-cmp-bool no" aria-label="no">&#10007;</span>'; }
  function priceCue(d) {
    if (!d.price) return txt('');
    if (d.compareAt) return '<span class="pg-cmp-prod__price"><span class="sale">' + esc(d.price) + '</span><span class="was">' + esc(d.compareAt) + '</span></span>';
    return '<span class="pg-cmp-prod__price">' + esc(d.price) + '</span>';
  }

  /* ---- rows: val() drives dim-the-matches, html() draws the cell ---- */
  var GROUPS = [
    { name: 'Overview', rows: [
      { label: 'Brand', val: function (d) { return d.vendor; }, html: function (d) { return txt(d.vendor); } },
      { label: 'Year', val: function (d) { return pick(d.tags, SET.year); }, html: function (d) { return txt(pick(d.tags, SET.year)); } },
      { label: 'Player', val: function (d) { return pick(d.tags, SET.player); }, html: function (d) { return txt(pick(d.tags, SET.player)); } },
      { label: 'Level', val: function (d) { return levelsOf(d.tags).join('/'); }, html: function (d) { return levelCue(d.tags); } },
      { label: 'Racket type', val: function (d) { return pick(d.tags, SET.type); }, html: function (d) { return typeCue(pick(d.tags, SET.type)); } }
    ] },
    { name: 'Playing feel', rows: [
      { label: 'Shape', val: function (d) { return d.specs.shape; }, html: function (d) { return shapeCue(d.specs.shape); } },
      { label: 'Balance', val: function (d) { return d.specs.balance; }, html: function (d) { return segCue(d.specs.balance, ['Low', 'Medium', 'High']); } },
      { label: 'Surface', val: function (d) { return d.specs.surface; }, html: function (d) { return txt(d.specs.surface); } },
      { label: 'Rubber hardness', val: function (d) { return pick(d.tags, SET.hardness); }, html: function (d) { return segCue(pick(d.tags, SET.hardness), SET.hardness); } }
    ] },
    { name: 'Construction', rows: [
      { label: 'Face material', val: function (d) { return d.specs.surface_material; }, html: function (d) { return txt(d.specs.surface_material); } },
      { label: 'Frame material', val: function (d) { return d.specs.frame_material; }, html: function (d) { return txt(d.specs.frame_material); } },
      { label: 'Core', val: function (d) { return d.specs.core; }, html: function (d) { return txt(d.specs.core); } },
      { label: 'Weight', val: function (d) { return d.specs.weight; }, html: function (d) { return txt(d.specs.weight); } }
    ] },
    { name: 'Price & stock', rows: [
      { label: 'Price', val: function (d) { return d.price; }, html: function (d) { return priceCue(d); } },
      { label: 'On sale', val: function (d) { return d.compareAt ? 'y' : 'n'; }, html: function (d) { return boolCue(!!d.compareAt); } },
      { label: 'In stock', val: function (d) { return d.available ? 'y' : 'n'; }, html: function (d) { return boolCue(!!d.available); } }
    ] }
  ];

  /* ---- state ---- */
  var current = null;
  function inList(h) { return load().some(function (x) { return x.handle === h; }); }
  function add(item) {
    var a = load(); if (a.some(function (x) { return x.handle === item.handle; })) return;
    if (a.length >= MAX) { flash('You can compare up to ' + MAX + ' rackets'); return; }
    a.push(item); save(a); refresh(); syncModal();
  }
  function remove(h) { save(load().filter(function (x) { return x.handle !== h; })); refresh(); syncModal(); }
  function replace(h, item) { var a = load(); for (var i = 0; i < a.length; i++) { if (a[i].handle === h) { a[i] = item; save(a); refresh(); syncModal(); return; } } }
  function clearAll() { save([]); closeModal(); refresh(); }

  /* ---- list-view (Globo collection card) compare buttons ----
     The card markup has no spec metafields, so we add basic data instantly for snappy
     feedback, then enrich from the product page's #pg-cmp-current JSON (same data the
     product page stores). A non-racket page has no such JSON, so it is declined. */
  var enrichCache = {};
  function handleFromCard(card) {
    var a = card.querySelector('.spf-product-card__title a') || card.querySelector('a[href*="/products/"]');
    var href = a ? (a.getAttribute('href') || '') : '';
    var seg = href.split('/products/')[1];
    return seg ? seg.split(/[?#]/)[0] : null;
  }
  function cardData(card, handle) {
    var t = card.querySelector('.spf-product-card__title a');
    var v = card.querySelector('.spf-product-card__vendor a') || card.querySelector('.spf-product-card__vendor');
    var img = card.querySelector('.spf-product-card__image-main') || card.querySelector('.spf-product-card__image');
    var price = card.querySelector('.spf-product-card__saleprice') || card.querySelector('.spf-product-card__price');
    var old = card.querySelector('.spf-product-card__oldprice');
    var src = img ? (img.getAttribute('src') || '') : '';
    if (!src || src.indexOf('data:image') === 0) src = img ? (img.getAttribute('data-src') || '') : '';
    return {
      handle: handle, title: t ? t.textContent.trim() : handle,
      url: t ? t.getAttribute('href') : '/products/' + handle, image: src,
      price: price ? price.textContent.trim() : '', compareAt: old ? old.textContent.trim() : null,
      available: !card.classList.contains('spf-soldout'), vendor: v ? v.textContent.trim() : '',
      tags: [], specs: {}
    };
  }
  function enrich(handle) {
    if (enrichCache[handle] !== undefined) return Promise.resolve(enrichCache[handle]);
    return fetch('/products/' + handle).then(function (r) { return r.text(); }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').getElementById('pg-cmp-current');
      var data = null; if (el) { try { data = JSON.parse(el.textContent); } catch (e) {} }
      enrichCache[handle] = data; return data;
    }).catch(function () { return null; });
  }
  function cardToggle(card) {
    var handle = handleFromCard(card); if (!handle) return;
    if (inList(handle)) { remove(handle); return; }
    if (load().length >= MAX) { flash('You can compare up to ' + MAX + ' rackets'); return; }
    var btn = card.querySelector('.pg-cmp-cardbtn'); if (btn) btn.classList.add('is-loading');
    add(cardData(card, handle));
    enrich(handle).then(function (full) {
      if (btn) btn.classList.remove('is-loading');
      if (full) replace(handle, full);
      else { remove(handle); flash('Compare is for Padel rackets'); }
    });
  }
  function injectCardBtns() {
    if (!window.PG_COMPARE_CARDS) return;
    document.querySelectorAll('.spf-product-card').forEach(function (card) {
      if (card.querySelector('.pg-cmp-cardbtn')) return;
      var price = card.querySelector('.spf-product-card__price-wrapper');
      var handle = handleFromCard(card);
      if (!price || !handle) return;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'pg-cmp-cardbtn'; btn.setAttribute('data-handle', handle);
      btn.innerHTML = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><rect x="2.5" y="3.5" width="6" height="13" rx="1.2"></rect><rect x="11.5" y="3.5" width="6" height="13" rx="1.2"></rect></svg><span class="pg-cmp-cardbtn__t">Compare</span>';
      price.insertAdjacentElement('afterend', btn);
    });
    refresh();
  }
  function watchCards() {
    if (!window.PG_COMPARE_CARDS || !window.MutationObserver) return;
    var target = document.querySelector('#gf-products') || document.querySelector('[id*="gf-products"]') || document.body;
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(injectCardBtns, 120); }).observe(target, { childList: true, subtree: true });
  }

  /* ---- UI build ---- */
  function prodCell(d) {
    var img = d.image ? '<img class="pg-cmp-prod__img" src="' + esc(d.image) + '" alt="' + esc(d.title) + '">' : '<span class="pg-cmp-prod__img"></span>';
    return '<div class="pg-cmp-prod"><button class="pg-cmp-prod__remove" data-remove="' + esc(d.handle) + '" aria-label="Remove">&times;</button>' +
      img + '<span class="pg-cmp-prod__title">' + esc(d.title) + '</span>' +
      '<span class="pg-cmp-prod__price">' + priceCue(d) + '</span>' +
      '<a class="pg-cmp-prod__view" href="' + esc(d.url) + '">View details</a></div>';
  }
  function tableHtml(items) {
    var head = '<tr><th class="pg-cmp-lbl"></th>';
    items.forEach(function (d) { head += '<th class="pg-cmp-col">' + prodCell(d) + '</th>'; });
    head += '</tr>';
    var body = '';
    GROUPS.forEach(function (g) {
      body += '<tr class="pg-cmp-band"><td colspan="' + (items.length + 1) + '">' + g.name + '</td></tr>';
      g.rows.forEach(function (r) {
        var vals = items.map(r.val);
        var same = items.length > 1 && vals.every(function (v) { return v && v === vals[0]; });
        body += '<tr class="' + (same ? 'pg-cmp-same' : '') + '"><th class="pg-cmp-lbl">' + r.label + '</th>';
        items.forEach(function (d) { body += '<td class="pg-cmp-col">' + r.html(d) + '</td>'; });
        body += '</tr>';
      });
    });
    return '<table class="pg-cmp-table"><thead>' + head + '</thead><tbody>' + body + '</tbody></table>';
  }

  var root;
  function refresh() {
    var a = load();
    document.querySelectorAll('.pg-cmp-add').forEach(function (btn) {
      var on = current && inList(current.handle);
      btn.classList.toggle('is-added', !!on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = btn.querySelector('.pg-cmp-add__label'); if (l) l.textContent = on ? 'Added to compare' : 'Add to compare';
    });
    document.querySelectorAll('.pg-cmp-toolbar').forEach(function (btn) {
      btn.classList.toggle('pg-cmp-toolbar--has', a.length > 0);
      var c = btn.querySelector('.pg-cmp-toolbar__count');
      if (c) { c.textContent = a.length; if (a.length > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); }
    });
    document.querySelectorAll('.pg-cmp-cardbtn').forEach(function (b) {
      var on = inList(b.getAttribute('data-handle'));
      b.classList.toggle('is-added', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var t = b.querySelector('.pg-cmp-cardbtn__t'); if (t) t.textContent = on ? 'Added' : 'Compare';
    });
    var bar = root.querySelector('.pg-cmp-bar');
    bar.classList.toggle('is-visible', a.length > 0);
    bar.querySelector('.pg-cmp-bar__thumbs').innerHTML = a.slice(0, 3).map(function (x) { return '<img src="' + esc(x.image) + '" alt="' + esc(x.title) + '">'; }).join('');
    bar.querySelector('.pg-cmp-bar__count').innerHTML = '<b>' + a.length + '</b> added';
    bar.querySelector('.pg-cmp-bar__open').disabled = a.length < 1;
  }
  /* Rebuild the open modal ONLY when the list changes (add/remove/replace) — never from a
     generic refresh(), or the MutationObserver's refreshes would reset scroll mid-drag. */
  function syncModal() { if (root.querySelector('.pg-cmp-overlay.is-open')) { load().length ? openModal() : openEmptyState(); } }
  function flash(msg) {
    var t = document.createElement('div'); t.className = 'pg-cmp-flash';
    t.textContent = msg; root.appendChild(t);
    setTimeout(function () { t.remove(); }, 2200);
  }
  var CLOSE_BTN = '<button class="pg-cmp-close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
  /* iOS Safari ignores body{overflow:hidden}, so pin the body with position:fixed (saving
     the scroll position) to lock the background without stealing the modal's scroll. */
  var lockedY = 0, scrollLocked = false;
  function lockScroll() {
    if (scrollLocked) return; scrollLocked = true;
    lockedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = (-lockedY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
  }
  function unlockScroll() {
    if (!scrollLocked) return; scrollLocked = false;
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.overflow = '';
    window.scrollTo(0, lockedY);
  }
  function openOverlay() {
    root.querySelector('.pg-cmp-overlay').classList.add('is-open');
    lockScroll();
  }
  function openModal() {
    var items = load();
    if (!items.length) { openEmptyState(); return; }
    var modal = root.querySelector('.pg-cmp-modal');
    modal.classList.remove('pg-cmp-modal--empty');
    var hint = items.length === 1 ? '<p class="pg-cmp-hint">Add another racket to compare them side by side.</p>' : '';
    modal.innerHTML =
      '<div class="pg-cmp-head"><h2 class="pg-cmp-head__title">Compare rackets</h2>' + CLOSE_BTN + '</div>' +
      '<div class="pg-cmp-body">' + hint + tableHtml(items) + '</div>';
    modal.style.maxWidth = window.innerWidth > 600 ? Math.min(900, 150 + items.length * 208) + 'px' : '';
    openOverlay();
  }
  function openEmptyState() {
    var modal = root.querySelector('.pg-cmp-modal');
    modal.classList.add('pg-cmp-modal--empty');
    modal.style.maxWidth = '';
    modal.innerHTML =
      '<div class="pg-cmp-head"><h2 class="pg-cmp-head__title">Compare rackets</h2>' + CLOSE_BTN + '</div>' +
      '<div class="pg-cmp-empty">' +
        '<span class="pg-cmp-empty__badge"><svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><rect x="2.5" y="3.5" width="6" height="13" rx="1.2"></rect><rect x="11.5" y="3.5" width="6" height="13" rx="1.2"></rect></svg></span>' +
        '<h3 class="pg-cmp-empty__title">No rackets to compare yet</h3>' +
        '<p class="pg-cmp-empty__msg">Browse our rackets and tap <b>Add to compare</b> to line them up side by side.</p>' +
        '<a class="pg-cmp-empty__btn" href="/collections/padel-rackets">View all rackets</a>' +
      '</div>';
    openOverlay();
  }
  function closeModal() {
    var o = root.querySelector('.pg-cmp-overlay'); if (o) o.classList.remove('is-open');
    unlockScroll();
  }

  function enhanceBuyRow() {
    try {
      var qty = document.querySelector('.hdt-product-info__item[data-type="quantity_selector"]');
      var buy = document.querySelector('.hdt-product-info__item[data-type="buy_buttons"]');
      if (!qty || !buy || qty.parentNode !== buy.parentNode || qty.closest('.pg-buymodule')) return;
      var add = document.querySelector('.pg-cmp-add');
      var mod = document.createElement('div'); mod.className = 'pg-buymodule';
      var row = document.createElement('div'); row.className = 'pg-buyrow';
      qty.parentNode.insertBefore(mod, qty);
      row.appendChild(qty);
      row.appendChild(buy);
      mod.appendChild(row);
      if (add) mod.appendChild(add);
    } catch (e) {}
  }

  function buyBtn() {
    return document.querySelector('.pg-buyrow [data-type="buy_buttons"] .hdt-btn-solid') ||
           document.querySelector('.pg-buyrow [data-type="buy_buttons"] button[name="add"]') ||
           document.querySelector('.pg-buyrow [data-type="buy_buttons"] .hdt-btn');
  }
  function syncBuyHeights() {
    var btn = buyBtn(), q = document.querySelector('.pg-buyrow .hdt-quantity-wrapp');
    if (btn && q) { var h = btn.getBoundingClientRect().height; if (h) q.style.height = Math.round(h) + 'px'; }
  }

  function init() {
    var data = document.getElementById('pg-cmp-current');
    if (data) { try { current = JSON.parse(data.textContent); } catch (e) {} }
    root = document.getElementById('pg-cmp-root') || document.body.appendChild(document.createElement('div'));
    root.classList.add('pg-cmp'); /* carry the --pg-* colour vars on every page, not just product pages */
    root.innerHTML =
      '<div class="pg-cmp-bar">' +
        '<div class="pg-cmp-bar__info"><div class="pg-cmp-bar__thumbs"></div><span class="pg-cmp-bar__count"><b>0</b> added</span></div>' +
        '<div class="pg-cmp-bar__actions">' +
          '<button class="pg-cmp-bar__open"><svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><rect x="2.5" y="3.5" width="6" height="13" rx="1.2"></rect><rect x="11.5" y="3.5" width="6" height="13" rx="1.2"></rect></svg>Compare</button>' +
          '<button class="pg-cmp-bar__clear" aria-label="Clear comparison"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</div>' +
      '</div>' +
      '<div class="pg-cmp-overlay"><div class="pg-cmp-modal pg-cmp-overlay__inner"></div></div>';

    document.querySelectorAll('.pg-cmp-add').forEach(function (btn) {
      btn.addEventListener('click', function () { if (!current) return; inList(current.handle) ? remove(current.handle) : add(current); });
    });
    document.querySelectorAll('.pg-cmp-toolbar').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); load().length ? openModal() : openEmptyState(); });
    });
    root.querySelector('.pg-cmp-bar').addEventListener('click', function (e) {
      if (e.target.closest('.pg-cmp-bar__clear')) clearAll(); else openModal();
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('.pg-cmp-close')) closeModal();
      else if (e.target.classList.contains('pg-cmp-overlay')) closeModal();
      var rm = e.target.closest('[data-remove]'); if (rm) remove(rm.getAttribute('data-remove'));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    document.addEventListener('click', function (e) {
      var cb = e.target.closest && e.target.closest('.pg-cmp-cardbtn');
      if (cb) { e.preventDefault(); cardToggle(cb.closest('.spf-product-card')); }
    });
    enhanceBuyRow();
    syncBuyHeights();
    var bb = buyBtn();
    if (window.ResizeObserver && bb) new ResizeObserver(syncBuyHeights).observe(bb);
    window.addEventListener('load', syncBuyHeights);
    window.addEventListener('resize', syncBuyHeights);
    injectCardBtns();
    watchCards();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
